const HomeFixedIcon = (props) => (
  <svg
    width={17}
    height={17}
    viewBox='0 0 17 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M6.23438 1.37305C7.19279 0.629727 8.73346 0.546069 9.79883 1.15332L10.0059 1.2832V1.28418L14.8965 4.70996C15.2424 4.95235 15.5884 5.36531 15.8486 5.86426C16.1087 6.36304 16.2499 6.88357 16.25 7.30859V13.0723C16.25 14.8265 14.8274 16.2499 13.0771 16.25H3.92285C2.17486 16.2499 0.750215 14.8206 0.75 13.0645V7.19824C0.750033 6.8059 0.876864 6.3118 1.11426 5.8291C1.32187 5.40698 1.59006 5.04368 1.86426 4.79492L1.98145 4.69531L6.2334 1.37207L6.23438 1.37305ZM8.5 9.66211C7.73685 9.66211 7.11328 10.2878 7.11328 11.0498V13.5996C7.11328 14.3616 7.73685 14.9873 8.5 14.9873C9.26315 14.9873 9.88672 14.3616 9.88672 13.5996V11.0498C9.88672 10.3356 9.33882 9.74059 8.6416 9.66895L8.5 9.66211Z'
      stroke='currentColor'
      strokeWidth={1.5}
    />
  </svg>
);
export default HomeFixedIcon;
